import { useState } from 'react'
// import Sidebar from '../../components/Common/Sidebar/Sidebar'
import AdminProfile from '../../components/AdminProfile/AdminProfile'
// import MobileSideBar from '../../components/MobileSideBar/MobileSideBar'
import ProfileForm from './ProfileForm'
// import { RxHamburgerMenu } from 'react-icons/rx'
// import OnBoardingForm from "./OnboardingForm";

function Profile() {
  const [isOpen, setIsOpen] = useState(false)
  const [isEditing, setIsEditing] = useState(false)

  return (
    <div className="w-full h-auto flex">
      <div className="admin-dashboard-card-section mx-auto w-full">
        <div className="w-[90%] md:w-[95%] h-auto mx-auto mt-[45px] flex justify-between items-center">
          <AdminProfile setIsOpen={setIsOpen} isOpen={isOpen} />
        </div>
        <div className="w-[90%] md:w-[95%] pb-[50px] mt-[10px] h-full mx-auto">
          <div className="w-full flex flex-col items-center mb-5 sm:mb-0 h-auto">
            {/* Dynamic title based on edit mode */}
            <h1 className="admin-dashboard">
              {isEditing ? 'Update Profile' : 'Profile Information'}
            </h1>
            {/* Pass editing state down */}
            <ProfileForm isEditing={isEditing} setIsEditing={setIsEditing} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Profile
